import React, { Dispatch, SetStateAction } from "react";
import { FontEnum, ITheme } from "~/styles/theme.type";
import { themeV2 } from "../theme";

export interface IGlobalStylesContext {
  theme: ITheme;
  setTheme: Dispatch<SetStateAction<ITheme>>;
  setFont: (font: FontEnum) => void;
  storeInformationInView: boolean;
  setStoreInformationInView: (value: boolean) => void;
}

const GlobalStylesContext = React.createContext<IGlobalStylesContext>({
  theme: themeV2,
  setTheme: () => {},
  setFont: () => {},
  storeInformationInView: false,
  setStoreInformationInView: (value: boolean) => {},
});

if (process.env.NODE_ENV !== "production") {
  GlobalStylesContext.displayName = "GlobalStylesContext";
}

export default GlobalStylesContext;
